import type { ReactNode } from "react";
import type { ReportDetailField } from "../../data/types";
import { RapportkatalogCardDescriptionAndDetails } from "./RapportkatalogCardDescriptionAndDetails";
import { RapportkatalogCardInfo } from "./RapportkatalogCardInfo";
import { RapportkatalogCardTitle } from "./RapportkatalogCardTitle";
import "./RapportkatalogCard.css";

type RapportkatalogCardProps = {
    title: string;
    area: string;
    owner: string;
    targetGroups: string;
    shortDescription: string;
    detailFields: ReportDetailField[];
    isLastChangedField: (field: ReportDetailField) => boolean;
    renderDetailValue: (value: string, label?: string) => ReactNode;
    renderLastChangedValue: (value?: string) => ReactNode;
};

export function RapportkatalogCard({
    title,
    area,
    owner,
    targetGroups,
    shortDescription,
    detailFields,
    isLastChangedField,
    renderDetailValue,
    renderLastChangedValue,
}: RapportkatalogCardProps) {
    const lastChangedField = detailFields.find((field) => isLastChangedField(field));
    const detailFieldsForCard = detailFields.filter((field) => !isLastChangedField(field));
    const infoItems = [
        { label: "Område", value: area || "-" },
        { label: "Eier", value: owner || "-" },
        { label: "Målgruppe", value: targetGroups || "-" },
        { label: "Sist oppdatert", value: renderLastChangedValue(lastChangedField?.value) },
    ];

    return (
        <article className="rapportkatalog-card">
            <div className="rapportkatalog-card-layout">
                <div className="rapportkatalog-card-left">
                    <RapportkatalogCardTitle title={title || "-"} />
                    <RapportkatalogCardDescriptionAndDetails
                        description={shortDescription || "-"}
                        detailFields={detailFieldsForCard}
                        renderDetailValue={renderDetailValue}
                    />
                </div>

                <div className="rapportkatalog-card-right">
                    <RapportkatalogCardInfo items={infoItems} />
                </div>
            </div>
        </article>
    );
}
